import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const LojaMateriais = () => {
  const wpp = generateWhatsAppLink('materiais', 'materiais-page');
  return (
    <div>
      <Helmet>
        <title>LED para Lojas de Materiais Elétricos | Sustenta LED</title>
        <meta name="description" content="Atacadista e distribuidora de LED para lojas de materiais elétricos. Mix completo, marcas homologadas e suporte técnico." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>LED para Lojas de Materiais Elétricos</h1>
              <p>Fornecemos LED para lojas de materiais elétricos com mix completo e condições comerciais competitivas. Somos atacadistas, distribuidores e representantes, apoiando ampliação de portfólio.</p>
              <p>Indicamos as melhores opções para cada aplicação, com qualidade, eficiência e reposição contínua.</p>
              <p>Solicite cotação e receba atendimento especializado para o seu negócio.</p>
              <div className="d-flex flex-column align-items-start">
                 <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                   <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                   Solicite agora a sua cotação e receba em até 1h
                 </a>
                 <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                   Voltar à página anterior
                 </button>
               </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/banner_como_trabalhamos.jpg" alt="LED para Lojas de Materiais Elétricos - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default LojaMateriais;
